import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

import { AppRoutePath } from '../../AppRoutePath';
import { isSurveyWasTriggeredOnAppStart } from '../../../modules/survey/survey.reactive-variables';
import { useTriggerSurveyOnMembershipCompleted } from './use-trigger-survey-on-membership-completed.hook';

export const useHomeSurveyEffect = () => {
  const surveyRouteMatch = useMatch(`${AppRoutePath.Home}${AppRoutePath.SurveyDetails}`);
  const shouldTriggerSurvey = !surveyRouteMatch;
  const { fetchAndOpenSurveyModal, triggerSurveyOnMembershipCompleted } = useTriggerSurveyOnMembershipCompleted();

  useEffect(() => {
    if (shouldTriggerSurvey) {
      triggerSurveyOnMembershipCompleted();
    } else {
      isSurveyWasTriggeredOnAppStart(true);
    }
  }, [triggerSurveyOnMembershipCompleted, shouldTriggerSurvey]);

  return { fetchAndOpenSurveyModal };
};
